import * as angular from 'angular';
import './styling.scss';
import * as template from './template.html';
import { CurrentUserService } from 'services/currentUser';
import { getEvidenceOfInsuranceDocument } from 'common/source/utilities/policyInfoHelper';
import { openUrlInNewTab } from 'common/source/utilities/windowHelper';
import { ModalService } from 'common/source/services/modal';
import * as hippoConstFactory from 'common/hippoConst.js';

const module = angular.module('quick-links-card', []);

interface QuickLinkCardController extends angular.IStrictController {
    policyInfos: Array<CustomerPolicyInfo>;
    updateEscrowLenderInformation: () => void;
    notifyLender: () => void;
    downloadEvidenceOfInsurance: () => void;
    addLoanNumber: () => void;
    openFaq: () => void;
    evidenceOfInsuranceUrl: string;
    showEscrowLenderInformation: boolean;
    showAddLoanNumber: boolean;
}

module.component('quickLinksCard', {
    template: template,
    bindings: {
        policyInfos: '<'
    },
    controller: function(
        this: QuickLinkCardController,
        currentUserService: CurrentUserService,
        $stateParams: StateParams,
        modalService: ModalService,
        $rootScope: angular.IRootScopeService,
        $scope: angular.IScope
    ) {
        this.$onInit = () => {
            updateDisplay($stateParams.policyIndex);

            const deregisterRootScopeListener = $rootScope.$on('updatedCustomerPolicyInfos', () => {
                updateDisplay($stateParams.policyIndex);
            });

            $scope.$on('$destroy', () => {
                deregisterRootScopeListener();
            });
        };

        this.$onChanges = () => {
            updateDisplay($stateParams.policyIndex);
        };

        const updateDisplay = (policyIndex?: RoutePolicyIndex) => {
            if (policyIndex) {
                currentUserService.getCustomerPolicyInfoByIndex(policyIndex).then((policyInfo) => {
                    const evidenceOfInsuranceDocument = getEvidenceOfInsuranceDocument(policyInfo);
                    this.evidenceOfInsuranceUrl = evidenceOfInsuranceDocument ? evidenceOfInsuranceDocument : '';

                    this.showEscrowLenderInformation = policyInfo.checkout_data.payment_method === 'escrow';
                    this.showAddLoanNumber = this.showEscrowLenderInformation && !policyInfo.checkout_data.loan_number;
                });
            }
        };

        this.downloadEvidenceOfInsurance = () => {
            if (this.evidenceOfInsuranceUrl) {
                openUrlInNewTab(this.evidenceOfInsuranceUrl);
            }
        };

        this.updateEscrowLenderInformation = () => {
            modalService.openCloseableModal('update-escrow-lender');
        };

        this.notifyLender = () => {
            modalService.openCloseableModal('notify-lender');
        };

        this.addLoanNumber = () => {
            modalService.openCloseableModal('update-escrow-lender', { preValidate: true });
        };

        this.openFaq = () => {
            const HIPPO_CONSTS = hippoConstFactory();
            openUrlInNewTab(HIPPO_CONSTS.FAQ_URL);
        };
    }
});

export { module };
